<template>
  <div class="big">
    <AddDrugs :isFlag="dialog" @refreshList="getList"></AddDrugs>
    <ImportData :isFlag="importdata" @refreshList="getList"></ImportData>
    <EditDrugs
      :isFlag="edit"
      :goodsId="goodsId"
      :hospitalName="hospitalName"
      @refreshList="getList"
    ></EditDrugs>
    <div class="page_title">平台药品管理</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>药房名称</span>
            <el-select
              v-model="hospital_id"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 400px"
            >
              <el-option
                v-for="item in hospitalOptions"
                :key="item.hospital_id"
                :label="item.hospital_name"
                :value="item.hospital_id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span>药品名称</span>
            <el-input
              placeholder="请输入"
              v-model="goods_name"
              style="width: 140px; margin: 0 5px 0 10px"
              @change="search"
              clearable
            ></el-input>
            <el-checkbox
              v-model="is_accurate"
              :true-label="1"
              :false-label="0"
              @change="search"
              >精确查询</el-checkbox
            >
          </div>
          <div class="item">
            <span>药品剂型</span>
            <el-select
              v-model="dosage_form"
              placeholder="请选择"
              style="width: 140px; margin-left: 10px"
              @change="search"
              clearable
            >
              <el-option
                v-for="item in dosage_form_list"
                :key="item.drug_type"
                :label="item.drug_type_name"
                :value="item.drug_type"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>编辑时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 225px; margin-left: 10px"
              @change="search"
              clearable
            ></el-date-picker>
          </div>
          <div class="item">
            <span>上架状态</span>
            <el-select
              v-model="buy_status"
              placeholder="请选择"
              style="width: 140px; margin-left: 10px"
              @change="search"
              clearable
            >
              <el-option
                v-for="(item, index) in status_list"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button
              type="primary"
              @click="search"
              size="medium"
              style="margin-left: 10px"
              >查询</el-button
            >
            <el-button plain @click="clearSearch" size="medium">重置</el-button>
          </div>
        </div>
        <div style="margin: 12px 0 16px 0" class="flex between">
          <span>
            <el-button
              type="primary"
              @click="showCopyBtn"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1815') : false
              "
              size="medium"
              >复制药房药材</el-button
            >
            <el-button
              type="primary"
              @click="addDrugs"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('703') : false
              "
              size="medium"
              >新建药品</el-button
            >
            <el-button
              plain
              @click="addData"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('704') : false
              "
              size="medium"
              >导入数据</el-button
            >
            <el-button
              plain
              @click="excelexport"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('698') : false
              "
              size="medium"
              >导出</el-button
            >
          </span>
          <span>
            <el-button
              type="primary"
              @click="batchUpdateGoodsRealStock"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1277') : false
              "
              size="medium"
              >批量修改真实库存</el-button
            >
            <el-button
              type="primary"
              @click="upSellAll"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('701') : false
              "
              size="medium"
              >批量上架</el-button
            >
            <el-button
              type="primary"
              @click="OffTheShelvesAll"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('701') : false
              "
              size="medium"
              >批量下架</el-button
            >
          </span>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            @selection-change="handleSelectionChange"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="changeOrder"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(0, 0, 0,0.1)"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              prop="hospital_name"
              label="药房名称"
            ></el-table-column>
            <el-table-column
              label="药品编码"
              width="100"
              prop="drug_code"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="goods_name"
              label="药品名称"
            ></el-table-column>
            <el-table-column
              prop="drug_type_name"
              label="剂型"
            ></el-table-column>
            <el-table-column
              prop="is_national_standard"
              width="100"
              label="是否为国标"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.drug_type_pid == 1">
                  {{ scope.row.is_national_standard == 1 ? "是" : "否" }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="dosage_unit_name" label="规格">
            </el-table-column>
            <el-table-column prop="cost_price" label="成本价" width="110">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.cost_price"
                  style="width: 100px"
                  v-if="scope.row.edit && scope.row.reviewed_status != 1"
                ></el-input>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="双击快捷修改药品价格及库存，修改价格后需平台审核"
                  placement="top"
                  v-else
                >
                  <span @dblclick="scope.row.edit = true">
                    {{ scope.row.cost_price }}
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="销售价" width="110">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.price"
                  style="width: 100px"
                  v-if="scope.row.edit && scope.row.reviewed_status != 1"
                ></el-input>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="双击快捷修改药品价格及库存，修改价格后需平台审核"
                  placement="top"
                  v-else
                >
                  <span @dblclick="scope.row.edit = true">
                    {{ scope.row.price }}
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="stock"
              label="理论库存"
              sortable="custom"
              width="110"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.stock"
                  style="width: 100px"
                  v-if="scope.row.edit && scope.row.reviewed_status != 1"
                ></el-input>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="
                    scope.row.stock < scope.row.stock_warning
                      ? '库存低于预警值'
                      : '双击快捷修改药品价格及库存，修改价格后需平台审核'
                  "
                  placement="top"
                  v-else
                >
                  <span
                    @dblclick="scope.row.edit = true"
                    :style="
                      scope.row.stock < scope.row.stock_warning
                        ? 'color:#ff514b'
                        : ''
                    "
                    >{{ scope.row.stock }}</span
                  >
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="real_stock"
              label="真实库存"
              sortable="custom"
              width="110"
            >
            </el-table-column>
            <el-table-column prop="stock_warning" label="预警值" />
            <el-table-column prop="expiry_time" label="有效期">
              <template slot-scope="scope">
                <span :style="scope.row.warning ? 'color:#ff514b' : ''">{{
                  scope.row.expiry_date
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="审核状态">
              <template slot-scope="scope">
                <span v-if="scope.row.reviewed_status == 1">审核中</span>
                <span v-if="scope.row.reviewed_status == 2">已通过</span>
                <span v-if="scope.row.reviewed_status == 3">未通过</span>
              </template>
            </el-table-column>
            <el-table-column label="上架状态">
              <template slot-scope="scope">
                <span v-if="scope.row.buy_status == 1">上架</span>
                <span v-if="scope.row.buy_status == 2">下架</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="update_time"
              label="编辑时间"
              width="102"
            ></el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <div v-if="scope.row.edit && scope.row.reviewed_status != 1">
                  <el-button
                    type="primary"
                    @click="editGoods(scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('716')
                        : false
                    "
                    size="medium"
                    >提交</el-button
                  >
                  <el-button plain @click="scope.row.edit = false" size="medium"
                    >取消</el-button
                  >
                </div>
                <div v-else>
                  <el-button
                    type="text"
                    @click="
                      editDrugs(scope.row.goods_id, scope.row.hospital_name)
                    "
                    v-if="
                      scope.row.buy_status == 2 || scope.row.buy_status == 3
                    "
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('705')
                        : false
                    "
                    >编辑</el-button
                  >
                  <el-button
                    v-if="scope.row.buy_status == 2"
                    @click="upSell(scope.row.goods_id)"
                    type="text"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('701')
                        : false
                    "
                    >上架</el-button
                  >
                  <el-button
                    @click="OffTheShelves(scope.row.goods_id)"
                    type="text"
                    v-if="scope.row.buy_status == 1"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('701')
                        : false
                    "
                    >下架</el-button
                  >

                  <el-button
                    @click="delGoods(scope.row.goods_id)"
                    type="text"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('702')
                        : false
                    "
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="padding: 20px 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 复制其他药房药材 -->
    <el-dialog
      title="复制其他药房药材"
      :visible.sync="dialogCopy"
      custom-class="copy-dialog"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="copyForm"
        ref="copyFormRef"
        label-width="120px"
        :rules="copyRules"
      >
        <el-form-item label="复制药房" prop="hospital_id">
          <el-select
            v-model="copyForm.hospital_id"
            placeholder="请选择"
            clearable
            size="small"
            @change="changeHospital"
          >
            <el-option
              v-for="item in hospital_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="复制药品剂型" prop="drug_type">
          <el-select
            v-model="copyForm.drug_type"
            placeholder="请选择"
            clearable
            size="small"
            @change="changeDrugType(copyForm.drug_type, 'drug_type')"
          >
            <el-option
              v-for="item in drug_type_options"
              :key="item.drug_type"
              :label="item.drug_type_name"
              :value="item.drug_type"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="复制至药房" prop="tar_hospital_id">
          <el-select
            v-model="copyForm.tar_hospital_id"
            placeholder="请选择"
            clearable
            size="small"
            @change="changeTarHospital"
          >
            <el-option
              v-for="item in hospital_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="复制后药品剂型" prop="tar_drug_type">
          <el-select
            v-model="copyForm.tar_drug_type"
            placeholder="请选择"
            clearable
            size="small"
            @change="changeDrugType(copyForm.tar_drug_type, 'tar_drug_type')"
          >
            <el-option
              v-for="item in tar_drug_type_options"
              :key="item.drug_type"
              :label="item.drug_type_name"
              :value="item.drug_type"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="复制类型" prop="copy_type">
          <el-select
            v-model="copyForm.copy_type"
            placeholder="请选择"
            clearable
            size="small"
            @change="changeCopyType"
          >
            <el-option
              v-for="item in copy_type_options"
              :key="item.copy_type"
              :label="item.name"
              :value="item.copy_type"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="复制数据"
          prop="copy_field_list"
          class="copy-field-list"
        >
          <el-checkbox
            v-for="(item, index) in copyForm.copy_field_list"
            :key="index"
            :true-label="1"
            :false-label="0"
            v-model="item.status"
            >{{ item.name }}</el-checkbox
          >
        </el-form-item>

        <el-form-item label="" class="copy-tip">
          <div class="content">
            注：复制药材时，会复制药品通知名、药品名称、药品厂家、规格、当量、有效期、成本价、销售价、期初库存。
            若复制后药房已有药材，则直接覆盖原药材信息
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCopy = false">取 消</el-button>
        <el-button type="primary" @click="copyConfirm('copyFormRef')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AddDrugs from "./AddDrugs.vue";
import ImportData from "./ImportData.vue";
import EditDrugs from "./EditDrugs";
import moment from "moment";
import dayjs from "dayjs";
import common from "../../../api/common";
import hospital from "../../../api/hospital";
export default {
  components: {
    AddDrugs,
    ImportData,
    EditDrugs,
  },
  data() {
    const validatePassCopyFieldList = (rule, value, callback) => {
      let is_empty = value.every((item) => !item.status);
      if (is_empty) {
        callback(new Error("请选择"));
      } else {
        callback();
      }
    };
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      hospitalList: [],
      hospital_id: "",
      dosage_form_list: [],
      date: [],
      loading: false,
      hospitalOptions: [],
      goods_name: "",
      is_accurate: 1,
      dosage_form: "",
      buy_status: "",
      orderby: 0,
      selectedId: "",
      selectedIdArr: [],
      dialog: false,
      importdata: false,
      todetail: false,
      edit: false,
      goodsId: "",
      status_list: [
        { label: "全部", value: 0 },
        { label: "上架", value: 1 },
        { label: "下架", value: 2 },
      ],
      loading: true,
      orderby: 0,
      hospitalName: "",
      dialogCopy: false,
      copyForm: {
        hospital_id: "",
        drug_type: "",
        tar_hospital_id: "",
        tar_drug_type: "",
        copy_type: "",
        copy_field_list: [],
      },
      copyRules: {
        hospital_id: [{ required: true, message: "请选择", trigger: "change" }],
        drug_type: [{ required: true, message: "请选择", trigger: "change" }],
        tar_hospital_id: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        tar_drug_type: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        copy_type: [{ required: true, message: "请选择", trigger: "change" }],
        copy_field_list: [
          {
            required: true,
            validator: validatePassCopyFieldList,
            trigger: "change",
          },
        ],
      },
      hospital_options: [],
      drug_type_options: [],
      tar_drug_type_options: [],
      copy_type_options: [],
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getDrugTypeList();
    this.getList();
    this.getHospital();
    this.getCopyGoodsTypeData();
  },
  methods: {
    // 药房搜索
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.hospitalOptions = this.hospitalList.filter((item) => {
            return (
              item.hospital_name.toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        }, 200);
      } else {
        this.hospitalOptions = this.hospitalList;
      }
    },
    //获取药房列表
    getHospital() {
      this.axios
        .post("platform/hospital/getHospitaList", {
          page: 1,
          pageNumber: 10000,
        })
        .then((res) => {
          this.hospitalList = res.data.list;
          this.hospitalOptions = res.data.list;
        });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.dosage_form_list = res.data.list;
        });
    },
    //获取药品列表
    getList() {
      this.loading = true;
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        hospital_id: this.hospital_id.toString(),
        buy_status: this.buy_status,
        dosage_form: this.dosage_form,
        goods_name: this.goods_name,
        is_accurate: this.is_accurate,
        orderby: this.orderby,
      };
      if (this.date && this.date.length > 0) {
        data.update_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.update_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/Goods/getHospitalDurgList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.update_time = item.update_time
                ? dayjs.unix(item.update_time).format("YYYY-MM-DD HH:mm")
                : "";
              if (item.expiry_date) {
                let diff = moment.unix(item.expiry_date).diff(moment(), "days");
                if (diff < 90) {
                  item.warning = true;
                }
                item.expiry_date = moment
                  .unix(item.expiry_date)
                  .format("yyyy-MM-DD");
              }
              item.edit = false;
              return item;
            });
            this.totalNum = res.data.total;
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      let prop = value.prop;
      //升序
      if (order == "ascending") {
        if (prop == "drug_code") {
          this.orderby = 1;
        }
        if (prop == "stock") {
          this.orderby = 3;
        }
        if (prop == "real_stock") {
          this.orderby = 5;
        }
      }
      //降序
      if (order == "descending") {
        if (prop == "drug_code") {
          this.orderby = 2;
        }
        if (prop == "stock") {
          this.orderby = 4;
        }
        if (prop == "real_stock") {
          this.orderby = 6;
        }
      }
      if (!order) {
        this.orderby = 0;
      }
      this.getList();
    },
    //新建药品
    addDrugs() {
      this.dialog = !this.dialog;
    },
    //导入数据
    addData() {
      this.importdata = !this.importdata;
    },
    //查看详情
    toDetail(goods_id) {
      this.todetail = !this.todetail;
      this.goodsId = goods_id;
    },
    //编辑药品弹窗
    editDrugs(goods_id, hospital_name) {
      this.edit = !this.edit;
      this.goodsId = goods_id;
      this.hospitalName = hospital_name;
    },
    //编辑商品
    editGoods(row) {
      let price = Number(row.price);
      let cost_price = Number(row.cost_price);
      let stock = Number(row.stock);
      let regPrice = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,4})?$/;
      let regStock = /^\d{0,6}$/;

      if (!regPrice.test(price) || !regPrice.test(cost_price)) {
        this.$message.error("价格请输入4位小数以内数字");
        return false;
      }
      if (!regStock.test(stock)) {
        this.$message.error("库存请输入6位以内正整数");
        return false;
      }

      let data = {
        goods_id: row.goods_id,
        price: row.price,
        cost_price: row.cost_price,
        stock: row.stock,
      };
      this.axios
        .post("platform/Goods/editGoodsPriceStock", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("药品信息已经更改");
            this.getList();
          }
        });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //清空搜索框
    clearSearch() {
      this.drug_code = "";
      this.goods_name = "";
      this.dosage_form = "";
      this.date = [];
      this.expiry_date = [];
      this.buy_status = "";
      this.hospital_id = "";
      this.getList();
    },
    //多选
    handleSelectionChange(val) {
      this.selectedIdArr = val.map((item) => {
        return item.goods_id;
      });
      this.selectedId = this.selectedIdArr.toString();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //上架
    upSell(goods_id) {
      let data = {
        goods_id,
        buy_status: 1,
      };
      this.axios.post("platform/Goods/offOnHospitalGoods", data).then((res) => {
        if (res.code === 0) {
          this.$message.success("药品已上架");
          this.getList();
        }
      });
    },
    //下架
    OffTheShelves(goods_id) {
      this.$confirm("下架后药品将不可被购买，确认下架吗？", "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            goods_id,
            buy_status: 2,
          };
          this.axios
            .post("platform/Goods/offOnHospitalGoods", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("药品已下架");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //删除
    delGoods(goods_id) {
      this.$confirm("删除不可恢复，请谨慎操作", "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "我再想想",
      })
        .then(() => {
          this.axios
            .post("platform/Goods/delHospitalGoods", { goods_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("药品已删除");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //批量上架
    upSellAll() {
      if (!this.selectedId) {
        this.$message.error("请先选择需要操作的药品");
        return false;
      }
      this.upSell(this.selectedId);
    },
    //批量下架
    OffTheShelvesAll() {
      if (!this.selectedId) {
        this.$message.error("请先选择需要操作的药品");
        return false;
      }
      this.OffTheShelves(this.selectedId);
    },
    //批量修改药品真实库存
    batchUpdateGoodsRealStock() {
      if (!this.selectedId) {
        this.$message.error("请先选择需要操作的药品");
        return false;
      }
      this.$prompt("请输入真实库存", "修改真实库存", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d{1,6}$/,
        inputErrorMessage: "请输入6位以内数字",
      })
        .then(({ value }) => {
          let data = {
            real_stock: value,
            goods_id: this.selectedId,
          };
          this.axios
            .post("platform/Goods/batchUpdateGoodsRealStock", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("库存已修改");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //导出数据
    excelexport() {
      let loading = this.$loading();
      let data = {
        hospital_id: this.hospital_id,
        buy_status: this.buy_status,
        dosage_form: this.dosage_form,
        goods_name: this.goods_name,
        orderby: this.orderby,
      };
      if (this.date && this.date.length > 0) {
        data.update_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.update_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/Goods/exportGoods", data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              "//" +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 复制药房
    showCopyBtn() {
      this.dialogCopy = true;
      this.getHospitaList();
      this.$refs["copyFormRef"] ? this.$refs["copyFormRef"].resetFields() : "";
    },
    // 获取药房
    getHospitaList() {
      const loading = this.$loading();
      const params = {
        page: 1,
        pageNumber: 10000,
      };
      hospital
        .getHospitaList(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.hospital_options = data.list.map((item) => {
              return {
                value: item.hospital_id,
                label: item.hospital_name,
              };
            });
          }
          loading.close();
        })
        .catch((err) => loading.close());
    },
    // 获取剂型
    getHospitalDrugList(hospital_id, keyName) {
      const loading = this.$loading();
      common
        .getHospitalDrugList({ hospital_id })
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            if (this.copyForm.hospital_id == this.copyForm.tar_hospital_id) {
              let itemKey = this.copyForm.drug_type
                ? "drug_type"
                : "tar_drug_type";

              this[keyName] = data.list.map((item) => {
                if (item.drug_type == this.copyForm[itemKey]) {
                  item.disabled = true;
                }
                return item;
              });
              console.log(keyName, this[keyName]);
            } else {
              this[keyName] = data.list;
            }
          }
          loading.close();
        })
        .catch((err) => loading.close());
    },
    // 获取复制药材选项
    getCopyGoodsTypeData(hospital_id) {
      hospital.getCopyGoodsTypeData({ hospital_id }).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.copy_type_options = data.list;
        }
      });
    },
    // 切换复制药房
    changeHospital(hospital_id) {
      if (hospital_id) {
        this.getHospitalDrugList(hospital_id, "drug_type_options");
      }
    },
    // 切换复制至药房
    changeTarHospital(hospital_id) {
      if (hospital_id) {
        this.getHospitalDrugList(hospital_id, "tar_drug_type_options");
      }
    },
    // 切换药品剂型
    changeDrugType(val, itemKey) {
      if (this.copyForm.hospital_id == this.copyForm.tar_hospital_id) {
        let keyName =
          itemKey == "tar_drug_type"
            ? "drug_type_options"
            : "tar_drug_type_options";

        this[keyName] = this[keyName].map((item) => {
          if (item.drug_type == this.copyForm[itemKey]) {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
          return item;
        });
      }
    },
    // 切换复制数据
    changeCopyType(val) {
      if (val === "") {
        this.copyForm.copy_field_list = [];
        return;
      }
      this.copy_type_options.map((item) => {
        if (item.copy_type == val) {
          this.copyForm.copy_field_list = item.list;
        }
      });
      console.log(this.copyForm.copy_field_list);
    },
    // 确认复制
    copyConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.copyForm.hospital_id == this.copyForm.tar_hospital_id &&
            this.copyForm.drug_type == this.copyForm.tar_drug_type
          ) {
            this.$message.warning("同一药房，药品剂型不能相同");
            return;
          }
          hospital.copyGoods(Object.assign({}, this.copyForm)).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success("操作成功");
              this.getList();
            }
            this.dialogCopy = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  position: relative;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 30px;
    margin-top: 16px;
  }
}
.dialog {
  padding: 20px;
}
</style>
<style lang="scss">
.mycheck .el-checkbox-group {
  display: flex;
  flex-direction: column;
  .el-checkbox {
    margin-bottom: 5px;
  }
}
.copy-dialog {
  .el-dialog__body {
    padding: 20px !important;
    .el-form-item {
      .el-select {
        width: 100%;
      }
    }
    .copy-field-list {
      .el-form-item__content {
        height: auto;
        display: flex;
        flex-wrap: wrap;
      }
    }
    .copy-tip {
      margin-bottom: 0;
      .el-form-item__content {
        height: auto;
        margin: 0 !important;
        .content {
          text-align: left;
          line-height: 20px;
        }
      }
    }
  }
}
</style>